function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.bc0{fill:url(#SVGID_3_);}\n\t.bc1{fill:url(#SVGID_4_);}\n\t.bc2{fill:#ECF4F8;}\n\t.bc3{font-family=\"Gotham-Bold, Gotham\";}\n\t.bc4{font-size:47px;}\n\t.bc5{font-size:64px;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "bc0",
  d: "M1052.7,844.1l0.4-0.4c0.3-0.2,0.5-0.4,1-0.8c0.4-0.4,0.6-0.5,0.6-0.5c15.6-9.4,30.2-21.3,46.4-37.2 c20.6-20.2,39.5-43.2,58-70c33.1-47.9,60.4-96.7,82.1-147.1c9.8-22.6,17.7-45.9,23.6-69.9c5.8-24.2,8.6-46.5,7.9-68.3 c-0.6-19.2-4-36.8-10.5-53.3c-0.9-2.4-1.7-4.2-3.6-8.3l-0.1-0.2c-0.9-1.9-1.3-2.8-1.8-3.9c0-0.1-0.1-0.2-0.1-0.3l-0.1-0.3 c-0.1-0.4-0.2-0.7-0.3-1l-0.2-0.7l-1.9-3.3l-3.1-5.4l-0.3-0.4c-0.3-0.4-0.6-0.8-1.2-1.6l-1.1-1.5c-0.9-1.2-1.5-2.1-2.2-3 c-9.5-13.2-21.1-24.8-34.3-34.3c-15.1-11-32.1-19.9-51.5-27.3c-21.1-8.1-43.7-13.9-69.3-18.4c-32.3-5.6-66.2-8.4-104.5-9.1 c-38.8-0.7-74.2,0.7-108.1,4.5c-24.8,2.6-49.4,7.3-73.5,13.9c-17.9,4.9-35.3,11.6-51.9,19.9c-0.6,0.3-1.2,0.5-1.9,0.7 c-0.8,0.3-1.2,0.4-1.7,0.6l-0.6,0.2l-10.9,6.3l-0.4,0.3c-0.5,0.4-0.9,0.7-1.7,1.3c-0.6,0.5-0.8,0.7-1.2,0.9c-1,0.8-1.7,1.3-2.4,1.8 c-9.8,6.5-18.8,14.1-26.9,22.6c-20.7,21.7-33.1,48-37.6,78.6c-2.8,19.5-2.4,39.6,0.9,61.4c3.1,20.5,8.4,41.2,16.1,63.4 c7.6,21.5,16.4,42.6,26.4,63.1c7.7,15.9,16.3,32.2,26.2,49.6c0.1,0.1,0.2,0.4,0.5,1.1c0.3,0.6,0.4,0.9,0.6,1.3l0.3,0.5l3.9,6.8 l0.3,0.3c0.2,0.3,0.4,0.5,0.7,0.9c0.3,0.3,0.3,0.4,0.3,0.4c1.9,3.1,3.4,5.6,6.9,11.3c8,13,11.5,18.8,16.1,26 c7.6,11.9,16,23.9,25.6,36.7c11.2,15,23.2,29.4,36.1,43.1c17.3,18.2,34.3,33,52.6,45c17.3,11.4,34.7,19.5,52.9,24.3 c26.2,7,53.9,6.1,79.6-2.5c8.9-2.8,17.5-6.5,25.6-11c0.2-0.1,0.4-0.2,0.6-0.3c0.2-0.1,0.3-0.1,0.6-0.2c0.5-0.2,0.8-0.3,1.2-0.5 l0.5-0.2l9.9-5.7l0,0l0.3-0.1L1052.7,844.1z M1035.3,835.6c-0.1,0-0.2,0.1-0.3,0.1c-0.4,0.1-0.6,0.2-0.8,0.3 c-0.9,0.4-1.8,0.8-2.7,1.3c-7.2,4-14.7,7.2-22.6,9.7c-22.8,7.6-47.3,8.4-70.5,2.2c-16.4-4.3-32.2-11.7-48.1-22.1 c-17.1-11.3-33.3-25.2-49.7-42.6c-12.4-13.2-24-27.2-34.9-41.7c-9.4-12.5-17.6-24.2-24.9-35.7c-4.5-7.1-8.1-12.8-16-25.7 c-3.5-5.7-5-8.2-7-11.4c-0.4-0.7-0.9-1.3-1.4-1.9c0-0.1-0.1-0.1-0.1-0.1l-3.3-5.7c-0.1-0.2-0.2-0.3-0.3-0.6 c-0.5-1.1-0.7-1.6-1.1-2.4c-9.8-17.3-18.2-33.3-25.8-48.9c-9.8-19.9-18.3-40.4-25.7-61.4c-7.4-21.3-12.5-41.1-15.4-60.5 c-3.1-20.4-3.5-39-0.9-56.8c3.9-27.3,14.9-50.5,33.3-69.8c7.3-7.6,15.5-14.5,24.3-20.3c1.1-0.7,2.1-1.5,3.4-2.5 c0.4-0.3,0.6-0.5,1.2-1c0.5-0.4,0.8-0.6,1.1-0.9l8.8-5.1c0.2-0.1,0.4-0.1,0.7-0.2c1.4-0.4,2.7-1,4-1.6c15.7-7.8,32-14.1,48.9-18.7 c23.3-6.4,47-10.9,71-13.4c33.1-3.8,67.8-5.1,106-4.4c37.5,0.7,70.6,3.4,102,8.9c24.6,4.3,46.3,9.9,66.3,17.6 c18.2,6.9,33.9,15.2,47.8,25.3c11.8,8.5,22.2,18.9,30.7,30.7c0.7,1,1.4,2,2.4,3.2c0.3,0.4,0.6,0.8,1.2,1.6l0.9,1.2l3.8,6.6l0.1,0.2 c0.2,0.7,0.5,1.4,0.8,2c0.4,0.9,0.8,1.9,1.7,3.8l0.1,0.2c1.7,3.7,2.5,5.4,3.2,7.4c5.8,14.7,8.8,30.6,9.4,48 c0.6,20.2-1.9,41.1-7.4,64c-5.7,23-13.3,45.5-22.8,67.3c-21.2,49.4-48.1,97.3-80.5,144.4c-17.9,26-36.2,48.3-56,67.7 c-15.4,15.1-29,26.3-43.4,34.9c-0.9,0.6-1.8,1.2-2.6,1.9c-0.1,0.1-0.1,0.1-0.2,0.1L1035.3,835.6z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "bc1",
  d: "M909.2,853.1c23.1-3.5,45.4-9.6,67.5-17.2c23.1-8.1,45.7-17.6,67.7-28.4c18.2-8.8,36-18.3,53.5-28.2 c1-0.6,2.1-1,3.2-1.5l7-4.1c0.7-0.5,1.3-1,1.9-1.5c13.5-8.3,27.1-16.5,40.4-25c13.5-8.6,26.6-17.9,39.4-27.5 c16.1-12,31.5-24.9,46.2-38.6c17.8-16.9,34.1-35.1,47.7-55.7c11.2-17,20-35.2,25.2-55c7.2-26.9,6.3-55.3-2.6-81.7 c-2.8-9.1-6.6-17.9-11.3-26.2c-0.6-1.2-1.1-2.4-1.6-3.7l-5.9-10.3c-0.7-0.8-1.4-1.6-2-2.5c-10.9-18.1-24.6-33.9-39.3-48.9 c-22.8-23.2-48.1-43.5-74.9-62c-50-34.6-102.7-64.5-158.6-88.5c-24.1-10.5-49.1-19-74.6-25.2c-23.6-5.7-47.6-9.1-72-8.3 c-19,0.6-37.4,3.8-55.1,10.8c-4.4,1.7-8.7,3.9-13.1,5.8c-0.7,0.3-1.5,0.6-2.3,0.8L795,231l-7.6,4.4c-2.2,1.7-4.4,3.3-6.7,4.9 c-13.6,9.8-25.6,21.8-35.4,35.4c-12.1,16.6-21.3,34.8-28.6,54c-9.1,23.9-15.2,48.6-19.6,73.8c-6.4,37.2-9.1,74.7-9.8,112.4 c-0.7,38.9,0.5,77.8,4.9,116.5c2.8,26.6,7.8,52.9,14.8,78.7c5.2,18.9,12.2,37.3,21,54.9c0.7,1.6,1.3,3.2,1.8,4.8l6.2,10.8 c1.6,2.1,3.3,4,4.7,6.2c6.8,10.1,14.6,19.4,23.3,27.9c22.7,21.7,49.9,34.1,80.8,38.6C866.4,857.1,887.8,856.3,909.2,853.1z"
});

var SvgBookCollections = function SvgBookCollections(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 647.9 656.5",
    style: {
      enableBackground: "new 0 0 647.9 656.5"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, React.createElement("g", {
    transform: "translate(-665.92 -213)"
  }, React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 758.1175,
    y1: 727.3581,
    x2: 1177.0739,
    y2: 296.5044
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4275FF"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83CEFF"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _ref3, React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 711.629,
    y1: 764.4398,
    x2: 1155.1613,
    y2: 308.3123
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4275FF"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83CEFF"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _ref4));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBookCollections, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/book-collections.e3e1f1c3.svg";
export { ForwardRef as ReactComponent };